import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
    return (
        <div className="min-h-screen" style={{background: 'linear-gradient(135deg, var(--app-color), #8B5CF6)'}}>
            {/* Header */}
            <header className="bg-white/90 backdrop-blur-sm border-b border-white/20">
                <div className="max-w-6xl mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{background: 'var(--app-color)'}}>
                                <span className="text-white font-bold text-lg">E</span>
                            </div>
                            <h1 className="text-xl font-bold text-gray-900">Esti.kz</h1>
                        </div>
                        <Link 
                            to="/" 
                            className="text-sm font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 flex items-center gap-2"
                            style={{background: 'var(--app-color)', color: 'white'}}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            Басты бетке оралу
                        </Link>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-4xl mx-auto px-4 py-8">
                <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-6 border border-white/20 mb-6">
                    <h1 className="text-3xl font-bold mb-6 text-gray-900">Cookie саясаты</h1>

                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Бұл Cookie саясаты біздің веб-сайтымызға кіргенде автоматты түрде жиналатын cookie файлдары туралы ақпаратты түсіндіреді. Біз cookie файлдарын қолданушыларға ыңғайлырақ қызмет көрсету үшін қолданамыз.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">1. Cookie деген не?</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Cookie - бұл сіздің құрылғыңызда немесе браузеріңізде сақталатын шағын мәтіндік файлдар. Олар сіздің веб-сайтта әрекет етуіңізді және қалауларыңызды есте сақтауға көмектеседі, осылайша сіз сайтты келесі рет қолданған кезде тәжірибеңізді жақсартады.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">2. Қандай cookie файлдары қолданылады?</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Біз екі түрлі cookie файлдарын қолданамыз:
                        <ul className="list-disc pl-6 mt-2 space-y-1 text-gray-700">
                            <li><strong>Сессия cookie файлдары</strong>: Бұл cookie файлдары тек сіз веб-сайтта бар кезде ғана қолданылады. Олар сессияны аяқтаған кезде өшіріледі.</li>
                            <li><strong>Тұрақты cookie файлдары</strong>: Бұл cookie файлдары бірнеше сессиялар бойы сақталады және келесі рет кіргенде веб-сайттың қызметтерін жеңілдетеді.</li>
                        </ul>
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">3. Cookie файлдары қалай пайдаланылады?</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Біз cookie файлдарын келесі мақсаттарда қолданамыз:
                        <ul className="list-disc pl-6 mt-2 space-y-1 text-gray-700">
                            <li>Қолданушының сайттағы әрекеттерін оңтайландыру және талдау жасау.</li>
                            <li>Сайтқа қайта кіргенде бұрынғы қалауларыңызды сақтау.</li>
                            <li>Пайдаланушының аутентификациясы үшін және сайттың функционалдық қызметтерін қамтамасыз ету үшін.</li>
                        </ul>
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">4. Cookie файлдарын қалай басқаруға болады?</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Егер сіз cookie файлдарын басқарғыңыз келсе, браузеріңіздің баптауларында cookie файлдарын өшіруге немесе басқаруға болады. Дегенмен, кейбір cookie файлдарын өшірген жағдайда, сайттың кейбір мүмкіндіктері дұрыс жұмыс істемеуі мүмкін.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">5. Cookie саясатындағы өзгерістер</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Біз бұл cookie саясатын уақыт өте келе жаңартып отыруымыз мүмкін. Барлық өзгерістер осы бетте жарияланады және жаңартылған дата көрсетіледі.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">6. Байланыс</h2>
                    <p className="text-gray-700 leading-relaxed">
                        Егер сізде осы cookie саясаты туралы сұрақтар болса, бізге <a href="mailto:musaaldanazarov@gmail.com" className="font-medium transition-colors hover:opacity-80" style={{color: 'var(--app-color)'}}>musaaldanazarov@gmail.com</a> мекенжайына хат жолдаңыз.
                    </p>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-white/10 backdrop-blur-sm border-t border-white/20 py-6 mt-8">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="text-center">
                        <p className="text-white/80 text-sm">
                            © {new Date().getFullYear()} Esti.kz. Барлық құқықтар қорғалған.
                        </p>
                        <p className="text-xs text-white/60 mt-1">
                            Отбасы хрестоматиясы
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default CookiePolicy;